<template>
  <div class="strip list_view">
    <div
      class="row no-gutters"
      style="cursor: pointer"
      @click="clickBooking()"
    >
      <div class="col-lg-5">
        <figure
          style="height: 100%"
          class="dark-background"
        >
          <a>
            <StoreImages
              :store="booking.store"
              :img-class="'img-cover'"
            />
          </a>
          <small>{{ $t('lang.categories.'+ booking.store.category_id).toUpperCase() }}</small>
        </figure>
      </div>
      <div class="col-lg-7">
        <div
          class="wrapper"
          style="padding-bottom: 0"
        >
          <h3 class="mb-3">
            {{ $t('lang.bookings.booking_number') + booking.id }}
          </h3>

          <BookingInfo
            :booking="booking"
            :styles="'small_info'"
          />
          <h3
            class="text-center"
            style="margin-bottom: 1rem"
          >
            <small>
              <b-link
                class=""
                href="#"
              >
                {{ $t('lang.bookings.see_details') }}
              </b-link>
            </small>
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BookingInfo from '@/components/Booking/BookingInfo';
import StoreImages from '@/components/Store/StoreImages';

export default {
  name: 'BookingCard',
  components: {
    BookingInfo,
    StoreImages,
  },
  props: {
    booking: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    clickBooking() {
      this.$emit('selectedBookingCard', this.booking);
    },
  },
};
</script>

<style scoped>
</style>
